/** Shared by the browser tracker and admin presence queries. */
export const ACTIVITY_HEARTBEAT_MS = 120_000;

// Allow a heartbeat interval plus one minute of delivery/scheduling grace.
// Presence is an estimate of recent activity, not proof of active attention.
export const ACTIVITY_ONLINE_WINDOW_MS = ACTIVITY_HEARTBEAT_MS + 60_000;

export function activityOnlineCutoff(now = Date.now()): string {
  return new Date(now - ACTIVITY_ONLINE_WINDOW_MS).toISOString();
}
